import { useRef, useLayoutEffect, useState } from "react";

/**
 * Auto-fits font size so the element's content fits in its parent box.
 * Uses a single-pass measurement to find the largest fitting size,
 * avoiding incremental shrink/grow which can oscillate on some browsers.
 */
export function useAutoFont(baseSize, minSize = 12) {
  const ref = useRef(null);
  const [fontSize, setFontSize] = useState(baseSize);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const parent = el.parentElement;
    if (!parent) return;

    // Single-pass: start at baseSize, shrink until it fits
    let size = baseSize;
    el.style.fontSize = size + 'px';
    while (
      (el.scrollWidth > parent.clientWidth || el.scrollHeight > parent.clientHeight) &&
      size > minSize
    ) {
      size--;
      el.style.fontSize = size + 'px';
    }
    el.style.fontSize = ''; // reset inline style, let React control it
    setFontSize(size);
  }, [baseSize, minSize]); // NOT dependent on fontSize — no oscillation possible

  return [ref, fontSize];
}
